import { RequirementType } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

import {
  RequirementTableCallback,
  RequirementTableItemData,
  RequirementTableRowConfig
} from "../../types";
import { buildConfigFields } from "../../utils";

import { usePayeeRegistrationConfig } from "./configs/payee/usePayeeRegistrationConfig";
import { usePayerRegistrationConfig } from "./configs/payer/usePayerRegistrationConfig";

export const useRegistrationRequirementTableConfig = (
  callback: RequirementTableCallback,
  requirements: RequirementTableItemData[]
): RequirementTableRowConfig[RequirementType.REGISTRATION] => {
  const payerRegistrationConfig = usePayerRegistrationConfig(callback);
  const payeeRegistrationConfig = usePayeeRegistrationConfig(callback);

  const fields = useMemo(
    () =>
      buildConfigFields<undefined, RequirementType.REGISTRATION>({
        payerConfig: payerRegistrationConfig,
        payeeConfig: payeeRegistrationConfig,
        getAdditionalData: () => undefined,
        // Sign-up status lives on the requirement itself, not on a document.
        hasDataSource: false
      })(),

    [payerRegistrationConfig, payeeRegistrationConfig]
  );

  return {
    ...fields,
    getAdditionalData: () => undefined,
    isLoading: false,
    isFetching: false,
    dataUpdatedAt: ""
  };
};
